import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { getDateString, getOrderPrefix } from "helpers/common_helper"
import { Type } from "react-bootstrap-table2-editor"
import { WindowScrollController } from "@fullcalendar/core"
import * as moment from "moment"

const columns = (
  toggle,
  handleValidDate,
  handleOrderClick,
  onClickDelete,
  toLowerCase1,
  toggleViewModal,
  designers,
  path
) => {
  const columns = [
    {
      dataField: "Sno",
      text: "S#",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1
      },
    },
    {
      dataField: "orderCode",
      text: "Order No",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <Link to="#" className="text-body fw-bold">
          {getOrderPrefix(row.requestFor) + row.orderCode}
        </Link>
      ),
    },

    {
      dataField: "submitDateTime",
      text: "Order Date",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cellContent, row) =>
        moment(new Date(row.submitDateTime)).format("DD MMM Y"),
    },
    {
      dataField: "userEmail",
      text: "User Email",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "userName",
      text: "Customers",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "paymentStatus",
      text: "Price Status",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cellContent, row) => (row.paymentStatus ? "Paid" : "Payable"),
      // moment(new Date(row.submitDateTime)).format("DD MMM Y")
    },
    {
      dataField: "assTo",
      text: "Designer",
      sort: true,
      editable: false,
    },
    {
      dataField: "assToSalesMan",
      text: "Sales Man",
      sort: true,
      editable: false,
    },

    {
      dataField: "price",
      text: "Order Amount",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
  ]

  let filterdColumns = []

  switch (window.location.pathname) {
    case "/designers-progress":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "userName" ||
          r.dataField === "paymentStatus" ||
          r.dataField === "price" ||
          r.dataField === "assTo" ||
          r.dataField === "userEmail"
      )
      break

    case "/sales-man-progress":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "userName" ||
          r.dataField === "paymentStatus" ||
          r.dataField === "salesPerson" ||
          r.dataField === "price" ||
          r.dataField === "assToSalesMan" ||
          
          r.dataField === "userEmail"
      )
      break

    case "/orders-report":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "userName" ||
          r.dataField === "paymentStatus" ||
          r.dataField === "price" ||
          r.dataField === "userEmail"
      )
      break

    case "/customers-report":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "userName" ||
          r.dataField === "paymentStatus" ||
          r.dataField === "price" ||
          r.dataField === "userEmail"
      )
      break

    case "/company-report":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "userName" ||
          r.dataField === "paymentStatus" ||
          r.dataField === "price"
      )
      break
  }

  return filterdColumns
}

columns.propTypes = {
  toggle: PropTypes.func,
  designers: PropTypes.object,
  handleValidDate: PropTypes.func,
  handleOrderClick: PropTypes.func,
  onClickDelete: PropTypes.func,
  locationPath: PropTypes.string,
}

export default columns
